import React from 'react'
import Error404 from '../../Error/Error404'

function Error404Page() {
  return (
    <div>
      <Error404/>
    </div>
  )
}

export default Error404Page
